import utils from '../../framework/js/app.utils';
import $ from 'jquery';
import React from 'react';
import { render } from 'react-dom';
import LightBox from '../../components/component-lightbox/component-lightbox';
import LightBoxCalendarContent from '../../components/component-lightbox/component-lightbox-calendar';
import LightBoxVideoContent from '../../components/component-lightbox/component-lightbox-video';

/*module: utlysning collection */

let moduleUtlysningCollection = {
  init() {
    let $context = $('.module-utlysning-collection, .module-puffblocks');
    
    if ($context.length === 0) return false;

    $context.each((i, el) => {
      let $currentContext = $(el),
      $calendarBlocks = $currentContext.find('[data-calendar-block-url]');
      if ($currentContext.hasClass('module-utlysning-collection--listview')) return;

      $calendarBlocks.each((i, el) => {
        $('<div class="react-render" />').appendTo(el);
      });

      $currentContext.find('[data-video-lightbox]').each((i, el) => {
        $('<div class="react-render" />').appendTo(el);
        this.handleVideoItem(el);
      });

      utils.checkInfoPuffs();
    });

    $(window).on('resize', () => utils.checkInfoPuffs());

    $('.date-item')
      .on('click', (e) => {
        e.stopPropagation();

        var $anchor = $(e.target).closest('.item-type--calendar');

        if (!$anchor.parent().parent().hasClass('large-24')) return false;
        
        this.renderLightBox($anchor.find('.react-render')[0], $anchor.attr('data-calendar-block-url'), "calendar").open();
      })
      .find('a').on('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        let $anchor, url;

        let clickedTarget = e.target;
        $anchor = e.target.tagName != "A" ? $(e.target).closest('.item-type--calendar') : $(clickedTarget);
        
        url = $anchor.attr('data-calendar-block-url');
        this.renderLightBox($anchor.find('.react-render')[0], url, "calendar").open();
      });

    $('.video-item a').on('click', (e) => {
      e.stopPropagation();
      e.preventDefault();

      var $anchor = $(e.target).closest('.item__content-wrapper');

      this.renderLightBox($anchor.find('.react-render')[0], $anchor.attr('data-video-url'), "video", $anchor.attr('data-video-type')).open();
    });
  },

  renderLightBox(appendTo, fetchUrl, type, videoType) {
    let component;

    if (type == "calendar") {
      component = render(
        <LightBox>
          <LightBoxCalendarContent fetchUrl={fetchUrl} />
        </LightBox>, appendTo);
    }

    if (type == "video") {
      component = render(
        <LightBox>
          <LightBoxVideoContent fetchUrl={fetchUrl} videoType={videoType} />
        </LightBox>, appendTo);
    }

    return component;
  },

  handleVideoItem(video) {
    let $video = $(video);
    let url = $video.attr('data-video-url');
    let title = $($video.find('.title')[0]).text().trim();

    if (title.length > 0) return false

    $.getJSON(
      'https://noembed.com/embed',
      {
        format: 'json',
        url: url
      },
      function (data) {
        if (data.title === undefined) return false;
        $($video.find('.title')[0]).find('span').text(data.title);
      }
    );
  },

};

export default moduleUtlysningCollection;
